import { alertRequest, body, request } from "services/request";

const resource = "api/truckingBids";

const addBidItemsChange = (params: {}) => alertRequest(`${resource}/addBidItemsChange`, body(params));

const deleteBidItemChange = (params: {}) => alertRequest(`${resource}/deleteBidItemChange`, body(params));

const editBidItemChange = (params: {}) => alertRequest(`${resource}/editBidItemChange`, body(params));

const getBidItemsChanges = (bidId: number, showSecondaryDrivers?: boolean | undefined) =>
    request(
        `${resource}/getBidItemsChanges?bidId=${bidId}${showSecondaryDrivers ? `&showSecondaryDrivers=true` : ""}`,
        { method: "GET" },
    );

const getBidForItemChangePointVisualization = (bidId: number, carId: number, itemChangeDateTime: string) =>
    request(
        `${resource}/getBidForItemChangePointVisualization?bidId=${bidId}&carId=${carId}&itemChangeDateTime=${itemChangeDateTime}`,
        {
            method: "GET",
        },
    );

export {
    addBidItemsChange,
    deleteBidItemChange,
    editBidItemChange,
    getBidItemsChanges,
    getBidForItemChangePointVisualization,
};
